export class CypressAttribute {
  buttons!: Record<string, string>;
  inputs!: Record<string, string>;
  views!: Record<string, string>;

  static buttons: Record<string, string> = {};
  static inputs: Record<string, string> = {};
  static views: Record<string, string> = {};
}
